import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { ApplyRootStateType } from './store';

export type OurAction<T> = { type: T };
export type OurActionWithPayload<T, P> = { type: T; payload: P };

export type ApplyThunkAction<R> = ThunkAction<R, ApplyRootStateType, never, AnyAction>;
export type ApplyThunkDispatch = ThunkDispatch<ApplyRootStateType, never, AnyAction>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApplyThunkCallback<A extends any[], R> = (api: ThunkApi, ...args: A) => R;

export type ThunkApi = {
    dispatch: ApplyThunkDispatch;
    getState: () => ApplyRootStateType;
};

export function createAction<T extends string>(type: T): OurAction<T>;
export function createAction<T extends string, P>(type: T, payload: P): OurActionWithPayload<T, P>;
export function createAction<T extends string, P>(type: T, payload?: P): OurAction<T> | OurActionWithPayload<T, P> {
    return payload ? { type, payload } : { type };
}
